/**
 * Manages sessionStorage operations for product comparison
 */
export class StorageManager {
  static KEYS = {
    IDS: 'product_lines_compared',
    IMAGES: 'product_lines_images',
    DESCRIPTIONS: 'product_lines_description'
  }

  readIDs() {
    const value = sessionStorage.getItem(StorageManager.KEYS.IDS)
    if (!value) return []
    
    return value.split(',')
      .map(Number)
      .filter(id => id !== 0)
  }

  readImages() {
    const value = sessionStorage.getItem(StorageManager.KEYS.IMAGES)
    if (!value) return []
    
    return value.split(',')
      .map(String)
      .filter(img => img.length > 0)
  }

  readDescriptions() {
    const value = sessionStorage.getItem(StorageManager.KEYS.DESCRIPTIONS)
    if (!value) return []
    
    return value.split(',')
      .map(String)
      .filter(desc => desc.length > 0)
  }

  save(ids, images, descriptions) {
    sessionStorage.setItem(StorageManager.KEYS.IDS, ids.join(','))
    sessionStorage.setItem(StorageManager.KEYS.IMAGES, images.join(','))
    sessionStorage.setItem(StorageManager.KEYS.DESCRIPTIONS, descriptions.join(','))
  }

  clear() {
    sessionStorage.removeItem(StorageManager.KEYS.IDS)
    sessionStorage.removeItem(StorageManager.KEYS.IMAGES)
    sessionStorage.removeItem(StorageManager.KEYS.DESCRIPTIONS)
    sessionStorage.removeItem('techflexProductCompare')
  }

  remove(idToRemove, imageToRemove, descToRemove) {
    const ids = this.readIDs().filter(id => id != idToRemove)
    const images = this.readImages().filter(img => img !== imageToRemove)
    const descriptions = this.readDescriptions().filter(desc => desc !== descToRemove)
    
    this.save(ids, images, descriptions)
  }
}
